<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class='elevation-2 animated fadeIn'>
                    <v-form v-model="valid" id="input-form" name="input-form" ref="form" action='/Account/ApplicationForgotPassword' method='post' enctype='application/x-www-form-urlencoded' v-on:submit.prevent='submit' autocomplete="off">
                        <v-toolbar flat>
                            <v-toolbar-title>Recuperar Contraseña</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field v-model='Email'
                                          name='Email'
                                          type='text'
                                          prepend-icon='person'
                                          label='Correo Electrónico'
                                          :rules="[v => !!v || 'El Correo Electrónico es requerido', v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El Correo Electrónico debe ser válido']"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn type='submit'><v-icon>done</v-icon>Someter</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import script from './script'
    export default script
</script>



// WEBPACK FOOTER //
// src/components/account/forgotPassword/component.vue